import Deck from './Deck'

export default Deck
